export const CAPITAL_ONE_SHOPPING_SDK_URL = `https://dmi.capitaloneshopping.com/cdn/sdk.js?programId=2f022fcd-cf1c-463c-abf0-fd6b5c8da228`;

/** Queues c1s calls until the Capital One Shopping SDK loads. */
export const capitalOneShoppingStubScript =
  'c1sData=window.c1sData||[];window.c1s||(c1s=function(){c1sData.push(arguments)});';

/**
 * Reads the Capital One Shopping click ID when the SDK has set one.
 * Returns undefined when the SDK is absent or no click ID is available.
 */
export const getCapitalOneShoppingClickId = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;

  try {
    const clickId = window.c1s?.getClickId?.();
    return typeof clickId === 'string' && clickId.length > 0
      ? clickId
      : undefined;
  } catch {
    return undefined;
  }
};
